<template>
    <v-flex class="my-2 row" xs12>
        <v-icon left medium>{{icon}}</v-icon>
        <span class="font-weight-bold" style="color: black; font-size: 15px;">
                           {{text}}</span>
    </v-flex>
</template>

<script>
    export default {
        name: "ConfirmationHeaderText",
        props: {
            text: {
                type: [String, Number, Boolean],
                default: false
            },
            icon: {
                type: [String],
                default: ''
            },
        },
    }
</script>
